import palette from '../../assets/colors';

const style = (theme) => ({
  minHeight: 'calc(100vh - 88px)',
  backgroundColor: palette[theme].background
});

export default style;